import { useState } from "react";
import { PiCheckFatLight } from "react-icons/pi";
import { SubscriptionData } from "../interfaces/Subscription";
import  { getSubscription } from "../config/keycloak";
import BaseLayout from "../components/layout/BaseLayout";
import { FormModal } from "../components/layout/Modal/Modal";
import { CheckOut } from "../components/checkout/CheckOut";
import { useKeycloak } from "@react-keycloak/web";

export const SubscriptionPage = () => {
    const { keycloak, initialized } = useKeycloak();
    const [showModal, setShowModal] = useState(false);
    const [currentSubscription, setCurrentSubscription] = useState<SubscriptionData>();
    const isFeatureBuyEnabled = process.env.REACT_APP_FEATURE_BUY === "true";

    const isBasicMember = () => getSubscription().includes('Basic Plan');
    const toggleModal = () => setShowModal((prev) => !prev);
    const checkOut = (subscription: SubscriptionData) => {
        setCurrentSubscription(subscription);
        toggleModal()
    };

    const canSubscribe = () => keycloak.tokenParsed?.preferred_username && isFeatureBuyEnabled;


    return (
        <BaseLayout>
            <div className="flex flex-col items-center bg-white py-10">
                <div className="text-xl text-gray-600 mb-5 max-w-[900px]">
                    <h3 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">Wähle den passenden Plan für deinen Betrieb</h3>
                    <p className="text-gray-600 text-base md:text-lg">Ob du klein startest oder professionelle Funktionen brauchst – mit unserem digitalen Feldkalender behältst du den Überblick. Entscheide dich für <strong>Free</strong>, um loszulegen, oder <strong>Basic</strong>, um alle Features uneingeschränkt zu nutzen.
                    </p>
                    <p className="text-gray-600 text-base md:text-lg pt-3">
                        Melde dich an oder erstelle einen{' '}
                        {initialized && keycloak ? (
                            <a className="font-bold text-green-700" href={keycloak.createRegisterUrl()}>
                                Account
                            </a>
                        ) : (
                            <span className="font-bold text-green-700">Account</span>
                        )}{' '}
                        und sichere dir den passenden Plan.
                    </p>
                    {!isFeatureBuyEnabled &&
                        <p className="text-gray-600 text-base md:text-lg py-4">Aktuell stehen die Pläne nicht zu Verfügung. Kommen Sie später wieder vorbei oder melden Sie sich unter <a href="mailto:hello@ackerplus.ch">hello@ackerplus.ch</a>.</p>
                    }
                </div>

                <div className="flex justify-center gap-8 flex-wrap mt-5">
                    <div className="bg-white p-7 pt-5 w-80 md:w-96 cursor-pointer rounded-xl subscription-option border-2 border-gray-300">
                        <div className="flex justify-between items-center">
                            <div className="flex flex-col items-start">
                                <h3 className="text-2xl font-bold mb-0">Free</h3>
                                <p className="text-gray-500 text-base">Ideal zum testen</p>
                            </div>
                            <div className="flex items-baseline">
                                <h3 className="text-4xl font-bold">0</h3>
                                <span className="text-xs font-semibold">CHF</span>
                            </div>
                        </div>
                        <div className="h-px w-full bg-gray-300 my-2"></div>
                        <div className="py-4 mb-12 space-y-4">
                            <div className="flex items-center gap-3">
                                <PiCheckFatLight color="#37813b" />
                                <p className="text-base text-gray-600">1 Betrieb</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <PiCheckFatLight color="#37813b" />
                                <p className="text-base text-gray-600">3 Parzellen</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <PiCheckFatLight color="#37813b" />
                                <p className="text-base text-gray-600">Schlagkarten exportieren</p>
                            </div>
                        </div>
                        <button className="bg-[#2F4F2F] hover:bg-[#37813b] text-white text-base font-medium py-2.5 px-14 rounded-lg transition-colors w-full">
                            Kostenlos
                        </button>
                    </div>

                    <div className="bg-white p-7 w-80 md:w-96 cursor-pointer rounded-xl subscription-option border-2 border-gray-300">
                        <div className="flex justify-between items-center">
                            <div className="flex flex-col items-start">
                                <h3 className="text-2xl font-bold mb-0 capitalize">Basic</h3>
                                <p className="text-gray-500 text-base">Alle Funktionen</p>
                            </div>
                            <div className="flex items-baseline">
                                <h3 className="text-4xl font-bold">50</h3>
                                <span className="text-xs font-semibold">CHF / Jahr</span>
                            </div>
                        </div>
                        <div className="h-px w-full bg-gray-300 my-2"></div>
                        <div className="py-4 mb-10 space-y-4">
                            <div className="flex items-center gap-3">
                                <PiCheckFatLight color="#37813b" />
                                <p className="text-base text-gray-600">Unlimitiert Betriebe</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <PiCheckFatLight color="#37813b" />
                                <p className="text-base text-gray-600">Unlimitiert Parzellen</p>
                            </div>
                            <div className="flex items-center gap-3">
                                <PiCheckFatLight color="#37813b" />
                                <p className="text-base text-gray-600">Schlagkarten exportieren</p>
                            </div>
                        </div>
                        {isBasicMember() && <button disabled className="bg-[gray] hover:bg-[#37813b] text-white text-base font-medium py-2.5 px-14 rounded-lg transition-colors w-full"> Gekauft</button>}
                        {canSubscribe() && !isBasicMember() && <button onClick={() => checkOut({ name: 'Basic', price: 50 })} disabled={isBasicMember()} className="bg-[#2F4F2F] hover:bg-[#37813b] text-white text-base font-medium py-2.5 px-14 rounded-lg transition-colors w-full"> Kaufen</button>}
                    </div>
                </div>
                {currentSubscription &&
                    <FormModal open={showModal} onClose={toggleModal}>
                        <CheckOut subscription={currentSubscription!} />
                    </FormModal>
                }
            </div>
        </BaseLayout>
    );
};